// extracted by mini-css-extract-plugin
export var addressFields = "_p5-0";
export var animationContainer = "_p5-1";
export var footer = "_p5-2";
export var lineItems = "_p5-3";
export var modalContent = "_p5-4";
export var orderName = "_p5-5";
export var strong = "_p5-6";
export var warning = "_p5-7";